<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      <b-img :src="footerLogo" width="110%" />
      <span class="ml-25" v-html="footerText" />
    </span>
    <span class="float-md-right d-block d-md-inline-block mt-25">
      <span class="font-italic">Best performance recommendation with Chrome or Firefox</span>
    </span>

    <!-- <span class="float-md-right d-none d-md-block">Hand-crafted &amp; Made with
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />
    </span> -->
  </p>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'

export default {
  components: {
    BLink,
    BImg,
  },

  data() {
    return {
      logo: require('@/assets/images/logotel_pot_d.png'),
    }
  },

  computed: {
    footerText: function() {
      return this.$store.state.app.settings.footer.copyright
    },
    footerLogo: function() {
      return (
        this.$store.state.app.settings.logo.footer ?? '/img/logotelkomindo.png'
      )
    },
  },
}
</script>
